<template>
  <v-form>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-list>
            <template v-for="(item, index) in (value.pmsBooksToSync || [])">
              <v-list-item :key="item.selectedMh1BookId+'Linked'">
                <v-list-item-icon>
                  <v-icon>mdi-calendar-account</v-icon>
                </v-list-item-icon>
                  <v-list-item-title v-text="getBookDisplayName(item)"></v-list-item-title>
                  <v-list-item-subtitle v-text="getResouceDescription(item)"></v-list-item-subtitle>
              </v-list-item>

              <v-list-item :key="item.selectedMh1BookId+'Connection'">
                <v-list-item-icon>
                  <v-icon>mdi-transit-connection</v-icon>
                </v-list-item-icon>


                <v-list-item-action>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon @click="manageBook(item)" v-on="on">
                        <v-icon color="primary">mdi-cog</v-icon>
                      </v-btn>
                    </template>

                    <span>Manage {{getBookDisplayName(item)}}</span>
                  </v-tooltip>
                </v-list-item-action>
                <v-list-item-action>
                  <v-btn icon @click="showBookInfo(item)">
                    <v-icon color="info lighten-2">mdi-information</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>

              <v-list-item :key="item.selectedMh1BookId+'olbAcc'">
                <v-list-item-icon>
                  <v-img :src="require('@/assets/mh1_icon.png')" width="32"></v-img>
                </v-list-item-icon>
                <v-list-item-title>
                  <a
                    :href="mh1BaseUri + 'appointmentBook/edit/' + item.selectedMh1BookId"
                    target="_blank"
                  >{{getMh1AppBookName(item.selectedMh1BookId)}}</a>
                  <v-icon  x-small class="pl-1 mt-n1">mdi-open-in-new</v-icon>
                </v-list-item-title>
                <v-list-item-subtitle></v-list-item-subtitle>
              </v-list-item>

              <v-divider v-if="index < (value.pmsBooksToSync || []).length" :key="index+'spacer'" :inset="false"></v-divider>
            </template>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
import ManageBookDialog from "./ManageBookDialog.vue";

import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@/graphql/queries";

export default {
  name: "ManageBooks",
  props: {
    value: Object,
    index: Number,
    pmsInfo: Object,
  },
  created: async function () {
    // this is always valid as one feature has to be selected
    console.log(
      "ManageBooks created",
      this.value?.existingMh1PracticeId,
      this.value?.newOrExisting
    );
    if (
      this.value?.existingMh1PracticeId &&
      this.value?.newOrExisting == "existing"
    ) {
      console.log(
        "ManageBooks created has valid details, getting practice treatments"
      );
      await this.getPracticeTreatments();
    }
    this.$emit("step-is-valid", 1);
  },
  data: function () {
    return {
      practiceTreatmentsInit: false,
      practiceTreatments: {},
      isLoading: false,
      mh1BaseUri: process.env.VUE_APP_MH1_BASE_URI,
    };
  },
  watch: {
    value: {
      async handler(newVal, oldVal) {
        console.log(
          "ManageBooks watch value",
          newVal.existingMh1PracticeId,
          oldVal.existingMh1PracticeId,
          newVal.newOrExisting,
          this.practiceTreatmentsInit
        );
        if (
          (!this.practiceTreatmentsInit &&
            newVal.existingMh1PracticeId &&
            newVal.newOrExisting == "existing") ||
          (newVal.existingMh1PracticeId != oldVal.existingMh1PracticeId &&
            newVal.newOrExisting == "existing")
        ) {
          this.practiceTreatmentsInit = true;
          console.log("ManageBooks watch value calling getPracticeTreatments");
          await this.getPracticeTreatments();
        }
      },
      deep: true,
    },
    practiceTreatments: {
      handler(val, oldVal) {
        console.log("!! practiceTreatments watch triggered", val, oldVal);
      },
      deep: true,
    },
    pmsInfo: {
      handler(val, oldVal) {
        console.log("ManageBooks watch pmsInfo", val, oldVal);
      },
    },
  },
  methods: {
    getPracticeTreatments: async function () {
      console.log("!! getPracticeTreatments called");
      this.isLoading = true;
      try {
        if (!this.value?.existingMh1PracticeId) {
          this.practiceTreatments = {};
          return;
        }

        const apiResult = await API.graphql(
          graphqlOperation(queries.getMh1PracticeTreatments, {
            practiceId: Number(this.value.existingMh1PracticeId),
          })
        );

        console.log("getMh1PracticeTreatmentsResult got", apiResult);

        if (!apiResult?.data?.getMh1PracticeTreatments) {
          console.log(
            "getMh1PracticeTreatmentsResult did not get results",
            apiResult
          );
          this.practiceTreatments = {};
          return;
        }

        this.practiceTreatments = apiResult.data.getMh1PracticeTreatments;
      } catch (err) {
        console.log("ManageBooks getPracticeTreatments err", err);
      } finally {
        this.isLoading = false;
      }
    },
    getBookDisplayName: function (bi) {
      return (
        bi.book.name ??
        bi.resources
          ?.map((r) => {
            if (r.name) {
              return `${r.title ?? ""} ${r.name ?? ""}`;
            } else {
              return `${r.title ?? ""} ${r.firstName ?? ""} ${r.surname ?? ""}`;
            }
          })
          ?.join(", ") ??
        "" ??
        bi.book.pmsBookFQId
      );
    },

    getResouceDescription: function (bi) {
      return (
        bi.resources
          ?.map(
            (r) =>
              [r.position ?? "", r.resourceType ?? ""]
                ?.filter((a) => a)
                ?.join(" - ") ?? []
          )
          ?.join(", ") ?? ""
      );
    },
    showBookInfo: function (bi) {
      this.$dialog.warning({
        text: JSON.stringify(bi, null, 4),
        title: `${this.getBookDisplayName(bi)} - Raw Info`,
        icon: "mdi-information",
        type: "primary",
        actions: ["Ok"],
      });
      return;
    },
    manageBook: async function (bi) {
      const mh1BookInfo =
        bi.newOrExisting == "existing"
          ? this.practiceTreatments?.appointmentBooks?.find(
              (b) => b.appointmentBookId == bi.selectedMh1BookId
            )
          : {};
      console.log(
        "mangeBok got mh1BookInfo for",
        mh1BookInfo,
        bi,
        this.practiceTreatments
      );
      const result = await this.$dialog.showAndWait(
       
        ManageBookDialog,
        {
          value: bi,
          mh1BookInfo,
          siteAppointmentTypes: this.selectedSite?.appointmentTypes ?? [],
          width: 800,
          pmsInfo: this.pmsInfo,
        },
        { width: 800 }
      );

      console.log("mange book got result", result, bi);

      if (result?.action == "ok") {
        //bi = result;
        bi.mappings = result.mappings;
         bi.appointmentTypes = result.AppointmentTypes;
        /*
        this.$emit("input", {
          ...this.value,
          timeZone: this.timeZone,
          wsUsername: this.wsUsername,
          wsPassword: this.wsPassword
      });*/
      }
    },
    getMh1AppBookName(mh1AppointmentBookId) {
      const foundBook = this.practiceTreatments?.appointmentBooks?.find(
              (b) => b.appointmentBookId == mh1AppointmentBookId
            );
      console.log(
        "getMh1AppBookName",
        mh1AppointmentBookId,
        foundBook,
        this.mh1BooksForPractice
      );
      if (!foundBook) return mh1AppointmentBookId;

      return [foundBook.practitionerName, foundBook.practitionerSurname].join(" ") ?? mh1AppointmentBookId;
    },
  },
};
</script>